import React, { memo } from "react";
import QuantityConfigurator from "../QuantityConfigurator";
import ClimateDetails from "../ClimateDetails";
import Headline from "../Typography/Headline";
import { AddonProps } from "./type";

/**
 * Returns a basic ingredient card
 * @returns JSX component
 */
const AddonCard = ({
    name,
    image,
    details,
    description = "",
    quantity,
    increment,
    decrement,
    tags,
}) => {
    const configuratorConfig = {
        increment,
        decrement,
        quantity,
    };

    const isBase = tags && tags.some((tag) => tag.includes("basis"));
    const isPrice = description && description.includes("€");
    const descriptionClass = isPrice ? "price" : "description";
    const isDisabledClass = !quantity ? "disabled" : "";
    const isBaseClass = isBase ? "base" : "";
    const componentOptionalClasses = `${isDisabledClass} ${isBaseClass}`;

    return (
        <div className={`addon-card ${componentOptionalClasses}`}>
            <div className="addon-card__upper">
                <img
                    className="addon-image"
                    src={image}
                    alt={name}
                    height={65}
                    width={65}
                />
                <div>
                    <Headline size={6} className="name">
                        {name}
                    </Headline>
                    <ClimateDetails
                        isSimple
                        climateDetails={details}
                        itemQuantity={quantity}
                    />
                </div>
            </div>
            <div className="addon-card__down">
                <span className={descriptionClass}>
                    {description && description}
                </span>
                <QuantityConfigurator {...configuratorConfig} />
            </div>
        </div>
    );
};

AddonCard.propTypes = AddonProps;

export default memo(AddonCard);
